export const LOAD_BACKGROUNDS = 'LOAD_BACKGROUNDS';



// WEBPACK FOOTER //
// ./src/redux/action-types/backgrounds/index.js